import { createContext } from "react";
import { contextFunctionInit } from "sprint-common-web";

import { WatermarkRuleItem } from "../listing/WatermarkRuleItem";

interface IWatermarkRuleContext {
    watermarkRuleItems: WatermarkRuleItem[];
    isLoading: boolean;
    setWatermarkRuleItems(watermarkRuleItems: WatermarkRuleItem[]): void;
    addWatermarkRuleItem(watermarkRuleItem: WatermarkRuleItem): void;
    deleteWatermarkRuleItem(watermarkRuleId: string): void;
    updateWatermarkRuleItem(item: WatermarkRuleItem): void;
}

const initialContextState: IWatermarkRuleContext = {
    watermarkRuleItems: [],
    isLoading: false,
    setWatermarkRuleItems: contextFunctionInit,
    addWatermarkRuleItem: contextFunctionInit,
    deleteWatermarkRuleItem: contextFunctionInit,
    updateWatermarkRuleItem: contextFunctionInit
};

export const WatermarkRuleContext = createContext<IWatermarkRuleContext>(initialContextState);
